import cx from 'classnames';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const RadioListItem = _ref => {
  let {
    children = '',
    extraClassName
  } = _ref;
  return ___EmotionJSX("span", {
    className: cx('dc-input-radio__text', extraClassName)
  }, children);
};
RadioListItem.displayName = 'RadioList.Item';
export default RadioListItem;